import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from './App.vue'
import { router } from './router'
import { useSessionStore } from './stores/session'
import './styles.css'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(router)

const session = useSessionStore(pinia)
session.configureClient()

router.beforeEach((to) => {
  const scopes = Array.isArray(to.meta.scopes) ? (to.meta.scopes as string[]) : []
  if (session.ready && session.authenticated && scopes.length > 0 && !session.canAny(scopes)) return '/'
  return true
})

app.mount('#app')
